import { CardWrapper, wrapperWidth } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { FormDefaultActions as Actions } from '@ami/react/core';
import { FormInput } from '@ami/react/core';

class ChangePasswordData extends React.PureComponent {
  render() {
    const { passwordCredentials, onUpdate } = this.props;
    const updatepasswordCredentials = (e) =>
      onUpdate({
        ...passwordCredentials,
        [e.target.id]: e.target.value,
      });

    return (
      <div>
        <FormInput
          id="currentPassword"
          type="password"
          label="Current Password"
          value={passwordCredentials.currentPassword}
          required
          onChange={updatepasswordCredentials}
        />
        <FormInput
          id="password"
          type="password"
          label="Password"
          value={passwordCredentials.password}
          required
          onChange={updatepasswordCredentials}
        />
        <FormInput
          id="confirmPassword"
          type="password"
          label="Confirm Password"
          value={passwordCredentials.confirmPassword}
          required
          onChange={updatepasswordCredentials}
        />
      </div>
    );
  }
}

class ChangePasswordForm extends React.Component {
  constructor() {
    super();
    this.form = React.createRef();
    this.validate = this.validate.bind(this);
    this.state = {
      showValidations: false,
    };
  }

  validate = () => {
    this.setState({ showValidations: true });
    return this.form.current.reportValidity();
  };

  render() {
    const {
      passwordCredentials,
      onSubmit,
      onCancel,
      submitting,
      onPasswordCredentialsUpdated,
      result,
    } = this.props;

    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit(this.validate());
    };

    return (
      <div className="show-validations">
        <CardWrapper title="Change Password" width={wrapperWidth.s}>
          <form onSubmit={handleSubmit} ref={this.form}>
            <ChangePasswordData
              passwordCredentials={passwordCredentials}
              onUpdate={onPasswordCredentialsUpdated}
            />
            <Actions
              onSubmit={handleSubmit}
              onCancel={onCancel}
              submitting={submitting}
            />

            {result && (
              <div>
                {(() => {
                  switch (result.status) {
                    case 'success':
                      return (
                        <Alert className="mt-3" color="success">
                          <i className="fa fa-info-circle fa-lg text-success" />{' '}
                          {result.message}
                        </Alert>
                      );
                    case 'error':
                      return (
                        <Alert className="mt-3" color="danger">
                          <i className="fa fa-info-circle fa-lg text-danger" />{' '}
                          {result.message}
                        </Alert>
                      );
                    default:
                      return null;
                  }
                })()}
              </div>
            )}
          </form>
        </CardWrapper>
      </div>
    );
  }
}

ChangePasswordForm.propTypes = {
  passwordCredentials: PropTypes.PropTypes.shape({
    password: PropTypes.string.isRequired,
    confirmPassword: PropTypes.string.isRequired,
  }).isRequired,
  result: PropTypes.PropTypes.shape({
    status: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }),
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPasswordCredentialsUpdated: PropTypes.func.isRequired,
};

export default ChangePasswordForm;
